import { makeStyles } from '@material-ui/core/styles';

import { SizeDimention } from '../../models/models';

const useStyles = makeStyles({
  card: {
    padding: '16px',
    overflowY: 'hidden',
    borderRadius: 0,
  },
  dynamicProp1: {
    marginTop: 2,
    marginBottom: 1,
    borderRadius: '0px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  otherPropText: {
    padding: '8.5px 0px 7.5px 4px',
    fontStyle: 'normal',
  },
  mainGrid: {
    flexDirection: 'row',
    display: (props: SizeDimention) =>
      props?.size?.height > props?.size?.width ? 'inline' : 'flex',
  },
  firstHalfGrid: {
    flexDirection: 'column',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  firstHalfBorder: {
    borderRadius: (props: SizeDimention & { firstHalfLength: number }) =>
      props?.size?.height > props?.size?.width || props?.firstHalfLength > 2
        ? '0px'
        : '0px 0px 0px 10px',
  },
  firstHalfInnerGrid: {
    display: 'flex',
    flexDirection: 'row',
    borderRadius: '0px',
  },
  firstHalfInnerGrid1: {
    marginBottom: (props: SizeDimention & { firstHalfLength: number }) =>
      props?.size?.height > props?.size?.width ? '' : props?.firstHalfLength > 2 ? '' : 4,
  },
  firstHalfValue: {
    overflowWrap: 'anywhere',
  },
  secondHalf: {
    display: 'flex',
    flexDirection: 'row',
  },
  viewMoreGrid: {
    paddingBottom: 6,
    borderRadius: '0px 0px 10px 10px',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  viewMoreAction: {
    cursor: 'pointer',
    padding: 0,
  },
  viewMoreButton: {
    verticalAlign: 'middle',
  },
  secondHalfBorderRadius: {
    borderRadius: (props: SizeDimention & { firstHalfLength: number }) =>
      props?.firstHalfLength > 2
        ? '0px'
        : props?.size?.height > props?.size?.width
        ? '0px 0px 10px 10px'
        : '0px 0px 10px 0px',
  },
  keyValue: {
    padding: '6px 16px 3px 16px',
  },
  keyValue1: {
    padding: '3px 16px',
  },
});

export default useStyles;
